import { CXF } from '@goodgamestudios/cxf-runtime'

import log from './utils/logger'

import { init as initTracking } from './tracking'
import { init as initGameController } from './games/game-controller'

export const init = (cxf: CXF) => {
  log('start initializing...')
  initTracking(cxf)
  initGameController(cxf)
}

// eslint-disable-next-line @typescript-eslint/no-var-requires, unicorn/prefer-top-level-await
require('@goodgamestudios/cxf-ready').then((cxf: CXF) => {
  init(cxf)
})
